export default {
  amp: 0,
  storage: {
    data: {
      key: 'ima_data',
      checksum: 'ima_data_checksum',
    },
    config: {
      key: 'ima_config',
      checksum: 'ima_config_checksum',
      ttl: 864000000,
    },
    debug: {
      key: 'ima_debug',
      value: 'yes, please',
    },
  },
  // Password for the storage
  password: '2cPJh2-t_FF-n5dsab6q=$KFQwL*gP',
  // basic metric ids
  basicMetrics: ['pi', 'visits', 'hourlyClients', 'dailyClients', 'weeklyClients', 'monthlyClients'],
  //
  webviewDetection: {
    ios: 'IMAHybridMessageHandler',
    android: 'IMAHybridBridge',
  },
  // Special sensor parameters
  specialParameter: {
    comment: {
      name: 'comment',
      short: 'co',
      type: 'string',
      strictRequired: false,
      default: '',
      maxLength: 255,
      allowed: ' -~',
      condition: {
        key: 'comment',
        value: true,
      },
    },
  },
  // initializing sensor parameters
  initParameter: {
    serviceDomainName: {
      name: 'serviceDomainName',
      short: 'dn',
      type: 'string',
      strictRequired: true,
      maxLength: 256,
      allowed: 'a-zA-Z0-9\\.\\-:',
    },
    site: {
      name: 'site',
      short: 'st',
      type: 'string',
      strictRequired: true,
      maxLength: 12,
      allowed: 'a-z_0-9',
    },
    code: {
      name: 'code',
      short: 'cp',
      type: 'string',
      maxLength: 254,
      default: 'Leercode_nichtzuordnungsfaehig',
      allowed: 'a-zA-Z0-9,_/\\-\\?\\#',
    },
    eventHandling: {
      name: 'eventHandling',
      short: 'eh',
      type: 'boolean',
      default: true,
    },
    privacySetting: {
      name: 'privacySetting',
      short: 'ps',
      type: 'stringEnum',
      default: 'none',
      allowed: 'extended|none|stop',
    },
    sentry: {
      name: 'sentry',
      short: 'sy',
      type: 'boolean',
      default: false,
    },
    localData: {
      name: 'localData',
      short: 'ld',
      type: 'stringEnum',
      default: 'all',
      allowed: 'nocookie|noiframe|all',
    },
    amp: {
      name: 'amp',
      short: 'ap',
      type: 'boolean',
      default: false,
    },
    ampUrl: {
      name: 'ampUrl',
      short: 'au',
      type: 'string',
      maxLength: 256,
      default: undefined,
      allowed: 'a-zA-Z0-9\\.\\-:/',
    },
    ampReferrer: {
      name: 'ampReferrer',
      short: 'ar',
      type: 'string',
      maxLength: 256,
      default: undefined,
      allowed: 'a-zA-Z0-9\\.\\-:/',
    },
    ampScreenHeight: {
      name: 'ampScreenHeight',
      short: 'ash',
      type: 'number',
      default: undefined,
    },
    ampScreenWidth: {
      name: 'ampScreenWidth',
      short: 'asw',
      type: 'number',
      default: undefined,
    },
  },
  // Specifies the cacheable xrh request types
  cacheableXhrTypes: [
    'panel',
    'category',
    'config',
  ],
  // check if event is whitelisted
  checkEvents: true,
  // List of available events
  eventList: [
    '', 'inst', 'init', 'open', 'clse', 'play', 'resm', 'stop',
    'fowa', 'bakw', 'recd', 'paus', 'forg', 'bakg', 'dele', 'refr',
    'kill', 'view', 'alve', 'fini', 'aforg', 'abakg', 'aclse', 'sple',
    'scvl', 'serr', 'spyr', 'smdr', 'sfpl', 'sfqt', 'ssqt', 'stqt',
    'soqt', 'sofc', 'scfc', 'scqt', 'splr', 'spli', 'sprs', 'spre',
    'smrs', 'smre', 'sors', 'sore', 'sack',
  ],
  // pi events
  piEventList: ['', 'open'],
  // RSA padding
  rsaPadding: 0,
  // Maximum count of stored codes for the local browser store (cookie and local storage)
  maxStoredCodes: 10,
  // Limit of present chars in cookie storage which is safe to store the first party cookie
  maxCookieStorageSize: 7000,
  // Secure modus
  secureMode: true,
};
